<template>
    <div :class="$style.container"
         id="loading"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)">

        <div style="overflow: hidden;padding: 25px">
            <div style="font-size: 22px;padding-top: 8px;float: left;width: 200px">
                销售数据录入设定
            </div>

            <div style="float:left;">
                <el-form  class="year">
                    <el-form-item label="">
                        <el-date-picker
                                v-model="form.year"
                                type="year"
                                placeholder="选择年"
                                format="yyyy"
                                value-format="yyyy"
                                @change="fangfa"
                                style="width: 120px;margin-left: -20px">
                        </el-date-picker>
                    </el-form-item>
                </el-form>
            </div>

            <div style="float: right">
                <el-button type="danger" size="" @click="$router.back()">返回</el-button>
            </div>
        </div>


        <div class="box" style="padding:0px 25px 25px 25px;margin-top: -10px">
            <el-table border :data="targetArray" stripe style="width: 100%" header-cell-class-name="headerStyle2">
                <el-table-column label="销售指标填写月份" width="90" >
                    <template slot-scope="scope">
                        <span style="font-size: 12px;color: #4A4A4A">开放填写时间</span>
                    </template>
                </el-table-column>

                <el-table-column
                        prop="m1"
                        label="1月"
                        minWidth="5px"
                        :render-header="renderHeader"

                >
                    <template slot-scope="scope">
                        <div v-for="item in scope.row.m1.array">
                            <span style="font-size: 12px; color: #909399">{{convdate(item.start_date)}}</span>
                            <span style="font-size: 12px; color: #909399; padding-right: 2px; padding-left: 2px">-</span>
                            <span style="font-size: 12px;color: #909399">{{convdate(item.end_date)}}</span>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                        prop="m2"
                        label="2月"
                        minWidth="5px"
                        :render-header="renderHeader"
                >
                    <template slot-scope="scope">
                        <div v-for="item in scope.row.m2.array">
                            <span style="font-size: 12px; color: #909399">{{ convdate(item.start_date)}}</span>
                            <span style="font-size: 12px; color: #909399; padding-right: 2px; padding-left: 2px">-</span>
                            <span style="font-size: 12px;color: #909399">{{convdate(item.end_date)}}</span>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                        prop="m3"
                        label="3月"
                        minWidth="5px"
                        :render-header="renderHeader"
                >
                    <template slot-scope="scope">
                        <div v-for="item in scope.row.m3.array">
                            <span style="font-size: 12px; color: #909399">{{convdate(item.start_date)}}</span>
                            <span style="font-size: 12px; color: #909399; padding-right: 2px; padding-left: 2px">-</span>
                            <span style="font-size: 12px;color: #909399">{{convdate(item.end_date)}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="m4"
                        label="4月"
                        minWidth="5px"
                        :render-header="renderHeader"
                >
                    <template slot-scope="scope">
                        <div v-for="item in scope.row.m4.array">
                            <span style="font-size: 12px; color: #909399">{{convdate(item.start_date)}}</span>
                            <span style="font-size: 12px; color: #909399; padding-right: 2px; padding-left: 2px">-</span>
                            <span style="font-size: 12px;color: #909399">{{convdate(item.end_date)}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="m5"
                        label="5月"
                        minWidth="5px"
                        :render-header="renderHeader"
                >
                    <template slot-scope="scope">
                        <div v-for="item in scope.row.m5.array">
                            <span style="font-size: 12px; color: #909399">{{convdate(item.start_date)}}</span>
                            <span style="font-size: 12px; color: #909399; padding-right: 2px; padding-left: 2px">-</span>
                            <span style="font-size: 12px;color: #909399">{{convdate(item.end_date)}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="m6"
                        label="6月"
                        minWidth="5px"
                        :render-header="renderHeader"
                >
                    <template slot-scope="scope">
                        <div v-for="item in scope.row.m6.array">
                            <span style="font-size: 12px; color: #909399">{{convdate(item.start_date)}}</span>
                            <span style="font-size: 12px; color: #909399; padding-right: 2px; padding-left: 2px">-</span>
                            <span style="font-size: 12px;color: #909399">{{convdate(item.end_date)}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="m7"
                        label="7月"
                        minWidth="5px"
                        :render-header="renderHeader"
                >
                    <template slot-scope="scope">
                        <div v-for="item in scope.row.m7.array">
                            <span style="font-size: 12px; color: #909399">{{convdate(item.start_date)}}</span>
                            <span style="font-size: 12px; color: #909399; padding-right: 2px; padding-left: 2px">-</span>
                            <span style="font-size: 12px;color: #909399">{{convdate(item.end_date)}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="m8"
                        label="8月"
                        minWidth="5px"
                        :render-header="renderHeader"
                >
                    <template slot-scope="scope">
                        <div v-for="item in scope.row.m8.array">
                            <span style="font-size: 12px; color: #909399">{{convdate(item.start_date)}}</span>
                            <span style="font-size: 12px; color: #909399; padding-right: 2px; padding-left: 2px">-</span>
                            <span style="font-size: 12px;color: #909399">{{convdate(item.end_date)}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="m9"
                        label="9月"
                        minWidth="5px"
                        :render-header="renderHeader"
                >
                    <template slot-scope="scope">
                        <div v-for="item in scope.row.m9.array">
                            <span style="font-size: 12px; color: #909399">{{convdate(item.start_date)}}</span>
                            <span style="font-size: 12px; color: #909399; padding-right: 2px; padding-left: 2px">-</span>
                            <span style="font-size: 12px;color: #909399">{{convdate(item.end_date)}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="m10"
                        label="10月"
                        minWidth="5px"
                        :render-header="renderHeader"
                >
                    <template slot-scope="scope">
                        <div v-for="item in scope.row.m10.array">
                            <span style="font-size: 12px; color: #909399">{{convdate(item.start_date)}}</span>
                            <span style="font-size: 12px; color: #909399; padding-right: 2px; padding-left: 2px">-</span>
                            <span style="font-size: 12px;color: #909399">{{convdate(item.end_date)}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="m11"
                        label="11月"
                        minWidth="5px"
                        :render-header="renderHeader"
                >
                    <template slot-scope="scope">
                        <div v-for="item in scope.row.m11.array">
                            <span style="font-size: 12px; color: #909399">{{convdate(item.start_date)}}</span>
                            <span style="font-size: 12px; color: #909399; padding-right: 2px; padding-left: 2px">-</span>
                            <span style="font-size: 12px;color: #909399">{{convdate(item.end_date)}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="m12"
                        label="12月"
                        minWidth="5px"
                        :render-header="renderHeader"
                >
                    <template slot-scope="scope">
                        <div v-for="item in scope.row.m12.array">
                            <span style="font-size: 12px; color: #909399">{{convdate(item.start_date)}}</span>
                            <span style="font-size: 12px; color: #909399; padding-right: 2px; padding-left: 2px">-</span>
                            <span style="font-size: 12px;color: #909399">{{convdate(item.end_date)}}</span>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column label="操作" width="100px" >
                    <template slot-scope="scope">
                        <el-button
                                size="mini"
                                @click="handelDelete(scope.row)"
                                style="margin-right: 10px;float: left;background-color: #ff9901;border: 1px solid #ff9901;color: #fff;width: 80px"
                        >批量设定
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="box" style="padding:0px 25px 25px 25px;margin-top: -10px">
            <el-table border :data="tableData2" stripe style="width: 100%" header-cell-class-name="headerStyle2">
                <el-table-column label="销量预估填写月份" width="90px">
                    <template slot-scope="scope">
                        <span style="font-size: 12px; color: #4A4A4A">开放填写时间</span>
                    </template>
                </el-table-column>

                <el-table-column
                        prop="m1"
                        label="1月"
                        minWidth="5px"
                        :render-header="renderHeader2"
                >
                    <template slot-scope="scope">
                        <div v-for="item in scope.row.m1.array">
                            <span style="font-size: 12px; color: #909399">{{convdate(item.start_date)}}</span>
                            <span style="font-size: 12px; color: #909399; padding-right: 2px; padding-left: 2px">-</span>
                            <span style="font-size: 12px;color: #909399">{{convdate(item.end_date)}}</span>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                        prop="m2"
                        label="2月"
                        minWidth="5px"
                        :render-header="renderHeader2"
                >
                    <template slot-scope="scope">
                        <p style="font-size: 12px;" v-for="item in scope.row.m2.array">{{convdate(item.start_date)}}-{{convdate(item.end_date)}}</p>
                    </template>
                </el-table-column>

                <el-table-column
                        prop="m3"
                        label="3月"
                        minWidth="5px"
                        :render-header="renderHeader2"
                >
                    <template slot-scope="scope">
                        <p style="font-size: 12px;" v-for="item in scope.row.m3.array">{{convdate(item.start_date)}}-{{convdate(item.end_date)}}</p>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="m4"
                        label="4月"
                        minWidth="5px"
                        :render-header="renderHeader2"
                >
                    <template slot-scope="scope">
                        <p style="font-size: 12px;" v-for="item in scope.row.m4.array">{{convdate(item.start_date)}}-{{convdate(item.end_date)}}</p>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="m5"
                        label="5月"
                        minWidth="5px"
                        :render-header="renderHeader2"
                >
                    <template slot-scope="scope">
                        <p style="font-size: 12px;" v-for="item in scope.row.m5.array">{{convdate(item.start_date)}}-{{convdate(item.end_date)}}</p>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="m6"
                        label="6月"
                        minWidth="5px"
                        :render-header="renderHeader2"
                >
                    <template slot-scope="scope">
                        <p style="font-size: 12px;" v-for="item in scope.row.m6.array">{{convdate(item.start_date)}}-{{convdate(item.end_date)}}</p>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="m7"
                        label="7月"
                        minWidth="5px"
                        :render-header="renderHeader2"
                >
                    <template slot-scope="scope">
                        <p style="font-size: 12px;" v-for="item in scope.row.m7.array">{{convdate(item.start_date)}}-{{convdate(item.end_date)}}</p>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="m8"
                        label="8月"
                        minWidth="5px"
                        :render-header="renderHeader2"
                >
                    <template slot-scope="scope">
                        <p style="font-size: 12px;" v-for="item in scope.row.m8.array">{{convdate(item.start_date)}}-{{convdate(item.end_date)}}</p>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="m9"
                        label="9月"
                        minWidth="5px"
                        :render-header="renderHeader2"
                >
                    <template slot-scope="scope">
                        <p style="font-size: 12px;" v-for="item in scope.row.m9.array">{{convdate(item.start_date)}}-{{convdate(item.end_date)}}</p>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="m10"
                        label="10月"
                        minWidth="5px"
                        :render-header="renderHeader2"
                >
                    <template slot-scope="scope">
                        <p style="font-size: 12px;" v-for="item in scope.row.m10.array">{{convdate(item.start_date)}}-{{convdate(item.end_date)}}</p>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="m11"
                        label="11月"
                        minWidth="5px"
                        :render-header="renderHeader2"
                >
                    <template slot-scope="scope">
                        <p style="font-size: 12px;" v-for="item in scope.row.m11.array">{{convdate(item.start_date)}}-{{convdate(item.end_date)}}</p>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="m12"
                        label="12月"
                        minWidth="5px"
                        :render-header="renderHeader2"
                >
                    <template slot-scope="scope">
                        <p style="font-size: 12px;" v-for="item in scope.row.m12.array">{{convdate(item.start_date)}}-{{convdate(item.end_date)}}</p>
                    </template>
                </el-table-column>

                <el-table-column label="操作" width="100px" >
                    <template slot-scope="scope">
                        <el-button
                                size="mini"
                                @click="handelDelete2(scope.row)"
                                style="margin-right: 10px;float: left;background-color: #ff9901;border: 1px solid #ff9901;color: #fff;width: 80px"
                        >批量设定
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

<!--        <div class="box" style="padding:0px 25px 25px 25px;margin-top: -10px">-->
<!--            <el-table border :data="tableData3" stripe style="width: 100%" header-cell-class-name="headerStyle2">-->
<!--                <el-table-column label="实际销量填写月份" width="90px">-->
<!--                    <template slot-scope="scope">-->
<!--                        <span style="font-size: 12px; color: #4A4A4A">开放填写时间</span>-->
<!--                    </template>-->
<!--                </el-table-column>-->

<!--                <el-table-column-->
<!--                        prop="m1"-->
<!--                        label="1月"-->
<!--                        minWidth="5px"-->
<!--                        :render-header="renderHeader3"-->
<!--                >-->
<!--                    <template slot-scope="scope">-->
<!--                        <div v-for="item in scope.row.m1.array">-->
<!--                            <span style="font-size: 12px; color: #909399">{{convdate(item.start_date)}}</span>-->
<!--                            <span style="font-size: 12px; color: #909399; padding-right: 2px; padding-left: 2px">-</span>-->
<!--                            <span style="font-size: 12px;color: #909399">{{convdate(item.end_date)}}</span>-->
<!--                        </div>-->
<!--                    </template>-->
<!--                </el-table-column>-->

<!--                <el-table-column-->
<!--                        prop="m2"-->
<!--                        label="2月"-->
<!--                        minWidth="5px"-->
<!--                        :render-header="renderHeader3"-->
<!--                >-->
<!--                    <template slot-scope="scope">-->
<!--                        <p style="font-size: 12px;" v-for="item in scope.row.m2.array">{{convdate(item.start_date)}}-{{convdate(item.end_date)}}</p>-->
<!--                    </template>-->
<!--                </el-table-column>-->

<!--                <el-table-column-->
<!--                        prop="m3"-->
<!--                        label="3月"-->
<!--                        minWidth="5px"-->
<!--                        :render-header="renderHeader3"-->
<!--                >-->
<!--                    <template slot-scope="scope">-->
<!--                        <p style="font-size: 12px;" v-for="item in scope.row.m3.array">{{convdate(item.start_date)}}-{{convdate(item.end_date)}}</p>-->
<!--                    </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column-->
<!--                        prop="m4"-->
<!--                        label="4月"-->
<!--                        minWidth="5px"-->
<!--                        :render-header="renderHeader3"-->
<!--                >-->
<!--                    <template slot-scope="scope">-->
<!--                        <p style="font-size: 12px;" v-for="item in scope.row.m4.array">{{convdate(item.start_date)}}-{{convdate(item.end_date)}}</p>-->
<!--                    </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column-->
<!--                        prop="m5"-->
<!--                        label="5月"-->
<!--                        minWidth="5px"-->
<!--                        :render-header="renderHeader3"-->
<!--                >-->
<!--                    <template slot-scope="scope">-->
<!--                        <p style="font-size: 12px;" v-for="item in scope.row.m5.array">{{convdate(item.start_date)}}-{{convdate(item.end_date)}}</p>-->
<!--                    </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column-->
<!--                        prop="m6"-->
<!--                        label="6月"-->
<!--                        minWidth="5px"-->
<!--                        :render-header="renderHeader3"-->
<!--                >-->
<!--                    <template slot-scope="scope">-->
<!--                        <p style="font-size: 12px;" v-for="item in scope.row.m6.array">{{convdate(item.start_date)}}-{{convdate(item.end_date)}}</p>-->
<!--                    </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column-->
<!--                        prop="m7"-->
<!--                        label="7月"-->
<!--                        minWidth="5px"-->
<!--                        :render-header="renderHeader3"-->
<!--                >-->
<!--                    <template slot-scope="scope">-->
<!--                        <p style="font-size: 12px;" v-for="item in scope.row.m7.array">{{convdate(item.start_date)}}-{{convdate(item.end_date)}}</p>-->
<!--                    </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column-->
<!--                        prop="m8"-->
<!--                        label="8月"-->
<!--                        minWidth="5px"-->
<!--                        :render-header="renderHeader3"-->
<!--                >-->
<!--                    <template slot-scope="scope">-->
<!--                        <p style="font-size: 12px;" v-for="item in scope.row.m8.array">{{convdate(item.start_date)}}-{{convdate(item.end_date)}}</p>-->
<!--                    </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column-->
<!--                        prop="m9"-->
<!--                        label="9月"-->
<!--                        minWidth="5px"-->
<!--                        :render-header="renderHeader3"-->
<!--                >-->
<!--                    <template slot-scope="scope">-->
<!--                        <p style="font-size: 12px;" v-for="item in scope.row.m9.array">{{convdate(item.start_date)}}-{{convdate(item.end_date)}}</p>-->
<!--                    </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column-->
<!--                        prop="m10"-->
<!--                        label="10月"-->
<!--                        minWidth="5px"-->
<!--                        :render-header="renderHeader3"-->
<!--                >-->
<!--                    <template slot-scope="scope">-->
<!--                        <p style="font-size: 12px;" v-for="item in scope.row.m10.array">{{convdate(item.start_date)}}-{{convdate(item.end_date)}}</p>-->
<!--                    </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column-->
<!--                        prop="m11"-->
<!--                        label="11月"-->
<!--                        minWidth="5px"-->
<!--                        :render-header="renderHeader3"-->
<!--                >-->
<!--                    <template slot-scope="scope">-->
<!--                        <p style="font-size: 12px;" v-for="item in scope.row.m11.array">{{convdate(item.start_date)}}-{{convdate(item.end_date)}}</p>-->
<!--                    </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column-->
<!--                        prop="m12"-->
<!--                        label="12月"-->
<!--                        minWidth="5px"-->
<!--                        :render-header="renderHeader3"-->
<!--                >-->
<!--                    <template slot-scope="scope">-->
<!--                        <p style="font-size: 12px;" v-for="item in scope.row.m12.array">{{convdate(item.start_date)}}-{{convdate(item.end_date)}}</p>-->
<!--                    </template>-->
<!--                </el-table-column>-->

<!--                <el-table-column label="操作" width="100px" >-->
<!--                    <template slot-scope="scope">-->
<!--                        <el-button-->
<!--                                size="mini"-->
<!--                                @click="handelDelete3(scope.row)"-->
<!--                                style="margin-right: 10px;float: left;background-color: #ff9901;border: 1px solid #ff9901;color: #fff;width: 80px"-->
<!--                        >批量设定-->
<!--                        </el-button>-->
<!--                    </template>-->
<!--                </el-table-column>-->
<!--            </el-table>-->
<!--        </div>-->

        <!--设定-->
        <el-dialog
                :visible.sync="dialogVisible"
                width="900px"
                :show-close="false"
                style="vertical-align: center;: #FFF9F3">
            <div style="margin-top: -40px">
                <el-row style="border-bottom: 2px dashed #e7eaec;padding-bottom: 10px;">
                    <el-col :span="12">
                        <div style="color: #3998F7;padding-top: 8px;font-size: 20px">设定填写规则 [{{form.year}}年{{column}} 销售指标]
                        </div>
                    </el-col>

                    <el-col :span="12">
                        <div align="right">
                            <el-button type="primary" size="small" @click="addSalesDate">
                                保存
                            </el-button>
                            <el-button type="danger" size="small" @click="dialogVisible = false">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
                <el-form ref="formlist" class="formlistStyle" :model="formlist" label-width="100px">
                <el-row style="margin-top: 20px;border: 1px solid #ededed;background-color: #f9f9f9">
                    <el-col :span="19" style="margin-top: 20px;margin-left: 15px">

                            <el-form-item label="开放填写时间">
                                <el-date-picker
                                        v-model="formlist.time"
                                        type="daterange"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                        value-format="yyyy-MM-dd"
                                        :clearable=true
                                >
                                </el-date-picker>
                            </el-form-item>

                    </el-col>
                    <el-col :span="4">
                        <el-button size="mini"style="background-color: #ff9901;color: #fff;border: 1px solid #ff9901;float: right;margin-top: 25px" @click="tianjia">添加规则</el-button>
                    </el-col>
                </el-row>
                <el-row style="margin-top: 20px">
                <el-col :span="2">
                   <label>填写规则</label>
                </el-col>
                 <el-col :span="22" style="border: 1px solid #ededed;border-radius: 3px;padding: 5px 10px 10px 5px">
                     <el-tag
                             color="#ff9901"
                             style="color: #fff;margin-left: 5px;border: 1px solid #ff9901;margin-top: 10px"
                             closable v-for="(item,index) in targetObj.array"
                             @close="handleClose(item,index)"
                     >{{item.start_date}}&nbsp - &nbsp{{item.end_date}}</el-tag>
                 </el-col>
                </el-row>
                </el-form>
            </div>
        </el-dialog>
        <!--设定2-->
        <el-dialog
            :visible.sync="dialogVisible3"
            width="900px"
            :show-close="false"
            style="vertical-align: center;: #FFF9F3">
        <div style="margin-top: -40px">
            <el-row style="border-bottom: 2px dashed #e7eaec;padding-bottom: 10px;">
                <el-col :span="12">
                    <div style="color: #3998F7;padding-top: 8px;font-size: 20px">设定填写规则 [{{form.year}}年{{column}} 销售预估]
                    </div>
                </el-col>

                <el-col :span="12">
                    <div align="right">
                        <el-button type="primary" size="small" @click="addSalesDate2">
                            保存
                        </el-button>
                        <el-button type="danger" size="small" @click="dialogVisible3 = false">
                            关闭
                        </el-button>
                    </div>
                </el-col>
            </el-row>
            <el-form ref="formlist2" class="formlistStyle" :model="formlist2" label-width="100px">
            <el-row style="margin-top: 20px;border: 1px solid #ededed;background-color: #f9f9f9">
                <el-col :span="19" style="margin-top: 20px;margin-left: 15px">

                        <el-form-item label="开放填写时间">
                            <el-date-picker
                                    v-model="formlist2.time"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    value-format="yyyy-MM-dd"
                                    :clearable=true
                            >
                            </el-date-picker>
                        </el-form-item>

                </el-col>
                <el-col :span="4">
                    <el-button size="mini"style="background-color: #ff9901;color: #fff;border: 1px solid #ff9901;float: right;margin-top: 25px" @click="tianjia2">添加规则</el-button>
                </el-col>
            </el-row>
            <el-row style="margin-top: 20px">
                <el-col :span="2">
                    <label>填写规则</label>
                </el-col>
                <el-col :span="22" style="border: 1px solid #ededed;height: 65px;border-radius: 3px;padding: 5px 10px 10px 5px">
                    <el-tag color="#ff9901"
                            style="color: #fff;border: 1px solid #ff9901;margin-left: 5px;"
                            closable
                            v-for="item in forecasObj.array"
                            @close="handleClose2(item,index)"
                    >{{item.start_date}}&nbsp - &nbsp{{item.end_date}}</el-tag>
                </el-col>
            </el-row>
            </el-form>
        </div>
    </el-dialog>
        <!--设定3-->
        <el-dialog
                :visible.sync="dialogVisible4"
                width="900px"
                :show-close="false"
                style="vertical-align: center;: #FFF9F3">
            <div style="margin-top: -40px">
                <el-row style="border-bottom: 2px dashed #e7eaec;padding-bottom: 10px;">
                    <el-col :span="12">
                        <div style="color: #3998F7;padding-top: 8px;font-size: 20px">设定填写规则 [{{form.year}}年{{column}} 实际销售]
                        </div>
                    </el-col>

                    <el-col :span="12">
                        <div align="right">
                            <el-button type="primary" size="small" @click="addSalesDate3">
                                保存
                            </el-button>
                            <el-button type="danger" size="small" @click="dialogVisible4 = false">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
                <el-form ref="formlist3" class="formlistStyle" :model="formlist3" label-width="100px">
                <el-row style="margin-top: 20px;border: 1px solid #ededed;background-color: #f9f9f9">
                    <el-col :span="19" style="margin-top: 20px;margin-left: 15px">

                            <el-form-item label="开放填写时间">
                                <el-date-picker
                                        v-model="formlist3.time"
                                        type="daterange"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                        value-format="yyyy-MM-dd"
                                        :clearable=true
                                >
                                </el-date-picker>
                            </el-form-item>

                    </el-col>
                    <el-col :span="4">
                        <el-button size="mini"style="background-color: #ff9901;color: #fff;border: 1px solid #ff9901;float: right;margin-top: 25px" @click="tianjia3">添加规则</el-button>
                    </el-col>
                </el-row>
                <el-row style="margin-top: 20px">
                    <el-col :span="2">
                        <label>填写规则</label>
                    </el-col>
                    <el-col :span="22" style="border: 1px solid #ededed;height: 65px;border-radius: 3px;padding: 5px 10px 10px 5px">
                        <el-tag
                                color="#ff9901"
                                style="color: #fff;border: 1px solid #ff9901"
                                closable v-for="item in actualObj.array"
                                @close="handleClose3(item,index)"
                        >{{item.start_date}}&nbsp - &nbsp{{item.end_date}}</el-tag>
                    </el-col>
                </el-row>
                </el-form>
            </div>
        </el-dialog>

        <!--批量设定-->
        <el-dialog
                :visible.sync="dialogVisible2"
                width="900px"
                :show-close="false"
                style="vertical-align: center;: #FFF9F3">
            <div style="margin-top: -40px">
                <el-row style="border-bottom: 2px dashed #e7eaec;padding-bottom: 10px;">
                    <el-col :span="12">
                        <div style="color: #3998F7;padding-top: 8px;font-size: 20px">批量设定填写规则 [{{form.year}}年 销售指标]
                        </div>
                    </el-col>

                    <el-col :span="12">
                        <div align="right">
                            <el-button type="danger" size="small" @click="dialogVisible2=false">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>

                <el-form ref="batchObj" class="formlistStyle" :model="batchObj" label-width="100px">
                <el-row style="margin-top: 40px">
                    <span style="color: #4A90E2;margin-top: 10px">批量设定方法1</span>
                </el-row>
                <el-row style="margin-top: 10px;border: 1px solid #ededed;background-color: #f9f9f9">
                   <el-row>
                       <el-col :span="19" style="margin-top: 20px;margin-left: 15px">
                               <el-form-item label="开放填写时间">
                                   <el-date-picker
                                           v-model="batchObj.time"
                                           type="daterange"
                                           range-separator="至"
                                           start-placeholder="开始日期"
                                           end-placeholder="结束日期"
                                           value-format="yyyy-MM-dd"
                                           format="yyyy-MM-dd"
                                           :clearable=true
                                   >
                                   </el-date-picker>
                               </el-form-item>
                       </el-col>
                       <el-col :span="4">
                           <el-button size="mini"style="background-color: #ff9901;color: #fff;border: 1px solid #ff9901;float: right;margin-top: 25px" @click="sheding">立即设定</el-button>
                       </el-col>
                   </el-row>

                    <el-row >
                            <el-col :span="8" style="margin-left: 15px">
                                <el-form-item label="允许填写范围">
                                    <el-date-picker
                                            v-model="batchObj.year"
                                            type="year"
                                            placeholder="选择年"
                                            format="yyyy"
                                            class="yearStyle"
                                            value-format="yyyy"
                                            style="width: 160px;">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                        <el-col :span="1">
                            <el-checkbox :indeterminate="isIndeterminate" v-model="batchObj.checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                        </el-col>

                        <el-col :span="13" style="margin-left: 30px;float: left" >
                            <el-checkbox-group v-model="batchObj.checkedCities" @change="handleCheckedCitiesChange">
                                <el-checkbox v-for="item in cities" :label="item.value" :key="item.name" >{{item.name}}</el-checkbox>
                            </el-checkbox-group>
                        </el-col>
                    </el-row>
                </el-row>

                    <el-row style="margin-top: 40px">
                        <span style="color: #4A90E2;margin-top: 10px">批量设定方法2</span>
                    </el-row>
                    <el-row style="margin-top: 10px;border: 1px solid #ededed;background-color: #f9f9f9">
                        <el-row>
                            <el-col :span="19" style="margin-top: 20px;margin-left: 15px;display: inline-block">
                                <el-form-item label="开放填写时间">
                                    <lable>每月</lable>
                                    <!--<el-input style="width: 82px" v-model="batchObj.input" type="number" max="28" min="1" onkeyup="value = value.replace(/[^1-28]/g,'')"></el-input>-->
                                    <el-select v-model="batchObj.day" placeholder="" style="width: 70px" @change="daySize">
                                        <el-option
                                                v-for="item in options"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value"
                                                :disabled="item.disabled"

                                        >
                                        </el-option>
                                    </el-select>
                                    <span>号</span><span style="margin-left: 10px">至</span>
                                    <el-select v-model="batchObj.methods" placeholder="请选择生效时间" style="width: 100px" @change="shengxiao">
                                        <el-option label="本月" value="D"></el-option>
                                        <el-option label="次月" value="C"></el-option>
                                    </el-select>
                                    <!--<el-input style="width: 82px" v-model="batchObj.input2" type="number" max="28" min="1" onkeyup="value = value.replace(/[^1-28]/g,'')"></el-input>-->
                                    <el-select v-model="batchObj.day2" placeholder="" style="width: 70px">
                                        <el-option
                                                v-for="item in options2"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value"
                                                :disabled="item.disabled">
                                        </el-option>
                                    </el-select>
                                    <span>号</span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4">
                                <el-button size="mini"style="background-color: #ff9901;color: #fff;border: 1px solid #ff9901;float: right;margin-top: 25px" @click="add">立即设定</el-button>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="19" style="margin-left: 15px;display: inline-block">
                                <el-form-item label="允许填写范围">
                                    <el-row>
                                        <el-checkbox v-model="batchObj.checked2">本月</el-checkbox>
                                    </el-row>
                                    <el-row>
                                        <el-checkbox v-model="batchObj.checked">未来</el-checkbox>
                                        <el-input-number v-model="batchObj.input3" controls-position="right" style="width: 82px;margin-left: 10px" :max="12" :min="1"></el-input-number><span>&nbsp;个月</span>
                                    </el-row>
<!--                                   <el-row>-->
<!--                                       <el-checkbox v-model="batchObj.checked3">未来</el-checkbox>-->
<!--                                       <el-input v-model="batchObj.input4" style="width: 82px;margin-left: 10px" type="number" max="28" min="1" onkeyup="value = value.replace(/[^1-28]/g,'')"></el-input><span>个月</span>-->
<!--                                   </el-row>-->
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-row>

                </el-form>
            </div>
        </el-dialog>

        <!--批量设定-->
        <el-dialog
                :visible.sync="dialogVisible5"
                width="900px"
                :show-close="false"
                style="vertical-align: center;: #FFF9F3">
            <div style="margin-top: -40px">
                <el-row style="border-bottom: 2px dashed #e7eaec;padding-bottom: 10px;">
                    <el-col :span="12">
                        <div style="color: #3998F7;padding-top: 8px;font-size: 20px">批量设定填写规则 [{{form.year}}年 销量预估]
                        </div>
                    </el-col>

                    <el-col :span="12">
                        <div align="right">
                            <el-button type="danger" size="small" @click="dialogVisible5 = false">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>

                <el-form ref="batchObj2" class="formlistStyle" :model="batchObj2" label-width="100px">
                    <el-row style="margin-top: 40px">
                        <span style="color: #4A90E2;margin-top: 10px">批量设定方法1</span>
                    </el-row>
                    <el-row style="margin-top: 10px;border: 1px solid #ededed;background-color: #f9f9f9">
                        <el-row>
                            <el-col :span="19" style="margin-top: 20px;margin-left: 15px">
                                <el-form-item label="开放填写时间">
                                    <el-date-picker
                                            v-model="batchObj2.time"
                                            type="daterange"
                                            range-separator="至"
                                            start-placeholder="开始日期"
                                            end-placeholder="结束日期"
                                            format="yyyy-MM-dd"
                                            value-format="yyyy-MM-dd"
                                            :clearable=true
                                    >
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4">
                                <el-button size="mini"style="background-color: #ff9901;color: #fff;border: 1px solid #ff9901;float: right;margin-top: 25px" @click="sheding2">立即设定</el-button>
                            </el-col>
                        </el-row>

                        <el-row >
                            <el-col :span="8" style="margin-left: 15px">
                                <el-form-item label="允许填写范围">
                                    <el-date-picker
                                            v-model="batchObj2.year"
                                            type="year"
                                            placeholder="选择年"
                                            format="yyyy"
                                            value-format="yyyy"
                                            style="width: 160px;">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="1">
                                <el-checkbox :indeterminate="isIndeterminate" v-model="batchObj2.checkAll" @change="handleCheckAllChange2">全选</el-checkbox>
                            </el-col>

                            <el-col :span="13" style="margin-left: 30px;float: left" >
                                <el-checkbox-group v-model="batchObj2.checkedCities" @change="handleCheckedCitiesChange2">
                                    <el-checkbox v-for="item in cities" :label="item.value" :key="item.name" >{{item.name}}</el-checkbox>
                                </el-checkbox-group>
                            </el-col>
                        </el-row>
                    </el-row>

                    <el-row style="margin-top: 40px">
                        <span style="color: #4A90E2;margin-top: 10px">批量设定方法2</span>
                    </el-row>
                    <el-row style="margin-top: 10px;border: 1px solid #ededed;background-color: #f9f9f9">
                        <el-row>
                            <el-col :span="19" style="margin-top: 20px;margin-left: 15px;display: inline-block">
                                <el-form-item label="开放填写时间">
                                    <lable>每月</lable>

                                    <el-select v-model="batchObj2.day" placeholder="" style="width: 70px" @change="daySize2">
                                        <el-option
                                                v-for="item in options"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value"
                                                :disabled="item.disabled"
                                        >
                                        </el-option>
                                    </el-select>
                                    <span>号</span><span style="margin-left: 10px">至</span>
                                    <el-select v-model="batchObj2.methods" placeholder="请选择生效时间" style="width: 100px" @change="shengxiao2">
                                        <el-option label="本月" value="D"></el-option>
                                        <el-option label="次月" value="C"></el-option>
                                    </el-select>
                                    <!--<el-input style="width: 52px" v-model="batchObj2.input2" type="number" max="28" min="1" onkeyup="value = value.replace(/[^1-28]/g,'')"></el-input>-->
                                    <el-select v-model="batchObj2.day2" placeholder="" style="width: 70px">
                                        <el-option
                                                v-for="item in options2"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value"
                                                :disabled="item.disabled">
                                        </el-option>
                                    </el-select>
                                    <span>号</span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4">
                                <el-button size="mini"style="background-color: #ff9901;color: #fff;border: 1px solid #ff9901;float: right;margin-top: 25px" @click="add2">立即设定</el-button>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="19" style="margin-left: 15px;display: inline-block">
                                <el-form-item label="允许填写范围">
                                    <el-row>
                                        <el-checkbox v-model="batchObj2.checked2">本月</el-checkbox>
                                    </el-row>
                                    <el-row>
                                        <el-checkbox v-model="batchObj2.checked">未来</el-checkbox>
                                        <el-input-number v-model="batchObj2.input3" controls-position="right" style="width: 82px;margin-left: 10px" :max="12" :min="1"></el-input-number><span>&nbsp;个月</span>
<!--                                        <el-input v-model="batchObj2.input3" style="width: 82px;margin-left: 10px" type="number" max="28" min="1" onkeyup="value = value.replace(/[^1-28]/g,'')"></el-input><span>个月</span>-->
                                    </el-row>
<!--                                    <el-row>-->
<!--                                        <el-checkbox v-model="batchObj2.checked3">未来</el-checkbox>-->
<!--                                        <el-input v-model="batchObj2.input4" style="width: 82px;margin-left: 10px" type="number" max="28" min="1" onkeyup="value = value.replace(/[^1-28]/g,'')"></el-input><span>个月</span>-->
<!--                                    </el-row>-->
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-row>

                </el-form>
            </div>
        </el-dialog>

        <el-dialog
                :visible.sync="dialogVisible6"
                width="900px"
                :show-close="false"
                style="vertical-align: center;: #FFF9F3">
            <div style="margin-top: -40px">
                <el-row style="border-bottom: 2px dashed #e7eaec;padding-bottom: 10px;">
                    <el-col :span="12">
                        <div style="color: #3998F7;padding-top: 8px;font-size: 20px">批量设定填写规则 [{{form.year}}年 实际销售]
                        </div>
                    </el-col>

                    <el-col :span="12">
                        <div align="right">
                            <el-button type="danger" size="small" @click="dialogVisible6 = false">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>

                <el-form ref="batchObj3" class="formlistStyle" :model="batchObj3" label-width="100px">
                    <el-row style="margin-top: 40px">
                        <span style="color: #4A90E2;margin-top: 10px">批量设定方法1</span>
                    </el-row>
                    <el-row style="margin-top: 10px;border: 1px solid #ededed;background-color: #f9f9f9">
                        <el-row>
                            <el-col :span="19" style="margin-top: 20px;margin-left: 15px">
                                <el-form-item label="开放填写时间">
                                    <el-date-picker
                                            v-model="batchObj3.time"
                                            type="daterange"
                                            range-separator="至"
                                            start-placeholder="开始日期"
                                            end-placeholder="结束日期"
                                            value-format="MM-dd"
                                            format="MM-dd"
                                            :clearable=true
                                    >
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4">
                                <el-button size="mini"style="background-color: #ff9901;color: #fff;border: 1px solid #ff9901;float: right;margin-top: 25px" @click="sheding3">立即设定</el-button>
                            </el-col>
                        </el-row>

                        <el-row >
                            <el-col :span="8" style="margin-left: 15px">
                                <el-form-item label="允许填写范围">
                                    <el-date-picker
                                            v-model="batchObj3.year"
                                            type="year"
                                            placeholder="选择年"
                                            format="yyyy"
                                            value-format="yyyy"
                                            style="width: 160px;">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="1">
                                <el-checkbox :indeterminate="isIndeterminate" v-model="batchObj3.checkAll" @change="handleCheckAllChange3">全选</el-checkbox>
                            </el-col>

                            <el-col :span="13" style="margin-left: 30px;float: left" >
                                <el-checkbox-group v-model="batchObj3.checkedCities" @change="handleCheckedCitiesChange3">
                                    <el-checkbox v-for="item in cities" :label="item.value" :key="item.name" >{{item.name}}</el-checkbox>
                                </el-checkbox-group>
                            </el-col>
                        </el-row>
                    </el-row>

                    <el-row style="margin-top: 40px">
                        <span style="color: #4A90E2;margin-top: 10px">批量设定方法2</span>
                    </el-row>
                    <el-row style="margin-top: 10px;border: 1px solid #ededed;background-color: #f9f9f9">
                        <el-row>
                            <el-col :span="19" style="margin-top: 20px;margin-left: 15px;display: inline-block">
                                <el-form-item label="开放填写时间">
                                    <lable>每月</lable>
                                    <el-select v-model="batchObj3.day" placeholder="" style="width: 70px" @change="daySize3">
                                        <el-option
                                                v-for="item in options"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value"
                                                :disabled="item.disabled"
                                        >
                                        </el-option>
                                    </el-select>
                                    <span>号</span><span style="margin-left: 10px">至</span>
                                    <el-select v-model="batchObj3.methods" placeholder="请选择生效时间" style="width: 100px" @change="shengxiao3">
                                        <el-option label="本月" value="D"></el-option>
                                        <el-option label="次月" value="C"></el-option>
                                    </el-select>
                                    <el-select v-model="batchObj3.day2" placeholder="" style="width: 70px">
                                        <el-option
                                                v-for="item in options2"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value"
                                                :disabled="item.disabled"
                                        >
                                        </el-option>
                                    </el-select>
                                    <span>号</span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4">
                                <el-button size="mini"style="background-color: #ff9901;color: #fff;border: 1px solid #ff9901;float: right;margin-top: 25px" @click="add3">立即设定</el-button>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="19" style="margin-left: 15px;display: inline-block">
                                <el-form-item label="允许填写范围">
                                    <el-row>
                                        <el-checkbox v-model="batchObj3.checked2">本月</el-checkbox>
                                    </el-row>
                                    <el-row>
                                        <el-checkbox v-model="batchObj3.checked">未来</el-checkbox>
                                        <el-input v-model="batchObj3.input3" style="width: 82px;margin-left: 10px" type="number" max="28" min="1" onkeyup="value = value.replace(/[^1-28]/g,'')"></el-input><span>个月</span>
                                    </el-row>
<!--                                    <el-row>-->
<!--                                        <el-checkbox v-model="batchObj3.checked3">未来</el-checkbox>-->
<!--                                        <el-input v-model="batchObj3.input4" style="width: 82px;margin-left: 10px" type="number" max="28" min="1" onkeyup="value = value.replace(/[^1-28]/g,'')"></el-input><span>个月</span>-->
<!--                                    </el-row>-->
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-row>

                </el-form>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    import Swiper from 'swiper'
    import 'swiper/css/swiper.min.css'
    import 'swiper/js/swiper.min.js'
    import http from '../../APIService/http'
    import ElForm from "../../../node_modules/element-ui/packages/form/src/form.vue";
    import { MessageBox, Message } from 'element-ui';
    export default {
        components: {ElForm},
        data(){
            return{
             form:{
                 year:''
             },
                options: [
                    {
                        value: '1',
                        label: '1',
                        disabled: false

                    }, {
                        value: '2',
                        label: '2',
                        disabled: false,

                    }, {
                        value: '3',
                        label: '3',
                        disabled: false

                    }, {
                        value: '4',
                        label: '4',
                        disabled: false

                    }, {
                        value: '5',
                        label: '5',
                        disabled: false

                    },{
                        value: '6',
                        label: '6',
                        disabled: false


                    },
                    {
                        value: '7',
                        label: '7',
                        disabled: false

                    }, {
                        value: '8',
                        label: '8',
                        disabled: false

                    }, {
                        value: '9',
                        label: '9',
                        disabled: false

                    }, {
                        value: '10',
                        label: '10',
                        disabled: false

                    }, {
                        value: '11',
                        label: '11',
                        disabled: false

                    }, {
                        value: '12',
                        label: '12',
                        disabled: false

                    },
                    {
                        value: '13',
                        label: '13',
                        disabled: false

                    }, {
                        value: '14',
                        label: '14',
                        disabled: false

                    }, {
                        value: '15',
                        label: '15',
                        disabled: false

                    }, {
                        value: '16',
                        label: '16',
                        disabled: false
                    }, {
                        value: '17',
                        label: '17',
                        disabled: false
                    }, {
                        value: '18',
                        label: '18',
                        disabled: false
                    },      {
                        value: '19',
                        label: '19',
                        disabled: false
                    }, {
                        value: '20',
                        label: '20',
                        disabled: false
                    }, {
                        value: '21',
                        label: '21',
                        disabled: false
                    }, {
                        value: '22',
                        label: '22',
                        disabled: false
                    }, {
                        value: '23',
                        label: '23',
                        disabled: false
                    }, {
                        value: '24',
                        label: '24',
                        disabled: false
                    },
                    {
                        value: '25',
                        label: '25',
                        disabled: false
                    }, {
                        value: '26',
                        label: '26',
                        disabled: false
                    },      {
                        value: '27',
                        label: '27',
                        disabled: false
                    }, {
                        value: '28',
                        label: '28',
                        disabled: false
                    }, {
                        value: '29',
                        label: '29',
                        disabled: false
                    }, {
                        value: '30',
                        label: '30',
                        disabled: false
                    },
                    {
                        value: '31',
                        label: '31',
                        disabled: false
                    },

                ],
                options2: [
                    {
                    value: '1',
                    label: '1',
                        disabled: false

                    }, {
                    value: '2',
                    label: '2',
                        disabled: false,

                    }, {
                    value: '3',
                    label: '3',
                        disabled: false

                    }, {
                    value: '4',
                    label: '4',
                        disabled: false

                    }, {
                    value: '5',
                    label: '5',
                        disabled: false

                    },{
                    value: '6',
                    label: '6',
                        disabled: false


                    },
                    {
                        value: '7',
                        label: '7',
                        disabled: false

                    }, {
                        value: '8',
                        label: '8',
                        disabled: false

                    }, {
                        value: '9',
                        label: '9',
                        disabled: false

                    }, {
                        value: '10',
                        label: '10',
                        disabled: false

                    }, {
                        value: '11',
                        label: '11',
                        disabled: false

                    }, {
                        value: '12',
                        label: '12',
                        disabled: false

                    },
                    {
                        value: '13',
                        label: '13',
                        disabled: false

                    }, {
                        value: '14',
                        label: '14',
                        disabled: false

                    }, {
                        value: '15',
                        label: '15',
                        disabled: false

                    }, {
                        value: '16',
                        label: '16',
                        disabled: false
                    }, {
                        value: '17',
                        label: '17',
                        disabled: false
                    }, {
                        value: '18',
                        label: '18',
                        disabled: false
                    },      {
                        value: '19',
                        label: '19',
                        disabled: false
                    }, {
                        value: '20',
                        label: '20',
                        disabled: false
                    }, {
                        value: '21',
                        label: '21',
                        disabled: false
                    }, {
                        value: '22',
                        label: '22',
                        disabled: false
                    }, {
                        value: '23',
                        label: '23',
                        disabled: false
                    }, {
                        value: '24',
                        label: '24',
                        disabled: false
                    },
                    {
                        value: '25',
                        label: '25',
                        disabled: false
                    }, {
                        value: '26',
                        label: '26',
                        disabled: false
                    },      {
                        value: '27',
                        label: '27',
                        disabled: false
                    }, {
                        value: '28',
                        label: '28',
                        disabled: false
                    }, {
                        value: '29',
                        label: '29',
                        disabled: false
                    }, {
                        value: '30',
                        label: '30',
                        disabled: false
                    },
                    {
                        value: '31',
                        label: '31',
                        disabled: false
                    },

                ],
                isIndeterminate:false,
                textarea:'',
                dialogVisible:false,
                dialogVisible2:false,
                dialogVisible3:false,
                dialogVisible4:false,
                dialogVisible5:false,
                dialogVisible6:false,
                formlist:{
                    time: '',
                },
                formlist2:{
                    time: '',
                },
                formlist3:{
                    time: '',
                },

                batchObj:{
                    time: '',
                    year:'',
                    checkedCities: [],
                    checkAll: false,
                    input3: '',
                    methods: 'C',
                    input4: '',
                    day:'',
                    day2:'',
                    checked:false,
                    checked2:false,
                    checked3:false,
                },
                batchObj2:{
                    time: '',
                    year:'',
                    checkedCities: [],
                    checkAll: false,
                    methods: 'C',
                    day:'',
                    day2:'',
                    input3: '',
                    input4: '',
                    checked:false,
                    checked2:false,
                    checked3:false,
                },
                batchObj3:{
                    time: '',
                    year:'',
                    checkedCities: [],
                    checkAll: false,
                    methods: 'C',
                    day:'',
                    day2:'',
                    input3: '',
                    input4: '',
                    checked:false,
                    checked2:false,
                    checked3:false,
                },

                tableData2:[],
                tableData3:[],
                column:'',
                cities:[
                    {name: '1月', value : "1"},
                    {name: '2月', value : "2"},
                    {name: '3月', value : "3"},
                    {name: '4月', value : "4"},
                    {name: '5月', value : "5"},
                    {name: '6月', value : "6"},
                    {name: '7月', value : "7"},
                    {name: '8月', value : "8"},
                    {name: '9月', value : "9"},
                    {name: '10月', value : "10"},
                    {name: '11月', value : "11"},
                    {name: '12月', value : "12"},
                ],
                targetArray:[],
                targetObj:{},
                forecasObj:{},
                actualObj:{},
                sales_month:'',
                month:[],
                current_month:'',
                value:''
            }
        },
        created(){
            this.form.year = new Date().Format('yyyy')
            this.getFillSalesDatesList()
        },
        methods:{

            convdate(timestamp){
                let date=''

                try {
                    if(timestamp){
                        let time=new Date(timestamp)
                        date= time.getFullYear()+'年'+(time.getMonth()+1)+'月'+time.getDate()+'日'
                    }
                }catch (e) {
                    date=''
                }
                return date
            },
            daySize(row){

                if(this.batchObj.methods=="D"){

                    if (parseInt(this.batchObj.day) != null){
                        if (parseInt(this.batchObj.day2) != null){

                            if (parseInt(this.batchObj.day) > parseInt(this.batchObj.day2)){
                                this.batchObj.day2 = ""
                            }
                        }
                        else {
                            this.batchObj.day2 = ""
                        }
                    }

                    if (parseInt(row) != null) {
                        let count = parseInt(row) - 1
                        if (count > 0) {
                            for (var i = 0; i < count; i++) {
                                let obj = this.options2[i];
                                obj.disabled = true
                            }
                        }
                    }
                }
            },
            shengxiao(row){
                console.log(row)

                if(row=="D"){
                    if (parseInt(this.batchObj.day) != null) {
                        let count = parseInt(this.batchObj.day) - 1
                        if (count > 0) {
                            for (var i = 0; i < count; i++) {
                                let obj = this.options2[i];
                                obj.disabled = true
                            }
                        }
                    }


                    if (parseInt(this.batchObj.day) != null){
                        if (parseInt(this.batchObj.day2) != null){

                            if (parseInt(this.batchObj.day) > parseInt(this.batchObj.day2)){
                                this.batchObj.day2 = ""

                            }
                        }
                        else {
                            this.batchObj.day2 = ""
                        }
                    }
                }
                else {
                    for (var i = 0; i < this.options2.length; i++) {
                        let obj = this.options2[i];
                        obj.disabled = false
                    }
                }
            },


            daySize2(row){

                if(this.batchObj2.methods=="D"){
                  if(parseInt(this.batchObj2.day)!==null) {
                      if(parseInt(this.batchObj2.day2)!==null){
                          if (parseInt(this.batchObj2.day)>parseInt(this.batchObj2.day2)){
                              this.batchObj2.day2=''
                          }
                      }else {
                          this.batchObj2.day2=''
                      }
                  }
                  if(parseInt(row)!=null){
                      let count = parseInt(row) - 1
                      if (count > 0) {
                          for (var i = 0; i < count; i++) {
                              let obj = this.options2[i];
                              obj.disabled = true
                          }
                      }
                  }
                }
            },
            shengxiao2(row){

              if(row=='D'){
                  if (parseInt(this.batchObj2.day) != null) {
                      let count = parseInt(this.batchObj2.day) - 1
                      if (count > 0) {
                          for (var i = 0; i < count; i++) {
                              let obj = this.options2[i];
                              obj.disabled = true
                          }
                      }
                  }

                  if (parseInt(this.batchObj2.day) != null){
                      if (parseInt(this.batchObj2.day2) != null){

                          if (parseInt(this.batchObj2.day) > parseInt(this.batchObj2.day2)){
                              this.batchObj2.day2 = ""

                          }
                      }
                      else {
                          this.batchObj2.day2 = ""
                      }
                  }
              }else {
                  for (var i = 0; i < this.options2.length; i++) {
                      let obj = this.options2[i];
                      obj.disabled = false
                  }
              }
            },

            daySize3(row){

                if(this.batchObj3.methods=="D"){
                    if(parseInt(this.batchObj3.day)!==null) {
                        if(parseInt(this.batchObj3.day2)!==null){
                            if (parseInt(this.batchObj3.day)>parseInt(this.batchObj3.day2)){
                                this.batchObj3.day2=''
                            }
                        }else {
                            this.batchObj3.day2=''
                        }
                    }
                    if(parseInt(row)!=null){
                        let count = parseInt(row) - 1
                        if (count > 0) {
                            for (var i = 0; i < count; i++) {
                                let obj = this.options2[i];
                                obj.disabled = true
                            }
                        }
                    }
                }
            },
            shengxiao3(row){

                if(row=='D'){
                    if (parseInt(this.batchObj3.day) != null) {
                        let count = parseInt(this.batchObj3.day) - 1
                        if (count > 0) {
                            for (var i = 0; i < count; i++) {
                                let obj = this.options2[i];
                                obj.disabled = true
                            }
                        }
                    }

                    if (parseInt(this.batchObj3.day) != null){
                        if (parseInt(this.batchObj3.day2) != null){

                            if (parseInt(this.batchObj3.day) > parseInt(this.batchObj3.day2)){
                                this.batchObj3.day2 = ""

                            }
                        }
                        else {
                            this.batchObj3.day2 = ""
                        }
                    }
                }else {
                    for (var i = 0; i < this.options2.length; i++) {
                        let obj = this.options2[i];
                        obj.disabled = false
                    }
                }
            },
            add(){
                this.batchSetSalesDatePlanTwo()
            },
            async batchSetSalesDatePlanTwo() {
                try {
                    let input3=''
                    if(this.batchObj.checked==true){
                         input3 = this.batchObj.input3
                    }else {
                         input3="0"
                    }
                    if(this.batchObj.checked2==true){
                        this.current_month=1
                    }else {
                        this.current_month="0"
                    }
                    let input4=''
                    if(this.batchObj.checked3==true){
                        input4 = this.batchObj.input4
                    }else {
                        input4="0"
                    }
                    this.loading=true
                    let data = {
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        user_id:this.$store.getters.getUser.user_id,
                        category:'TARGET',
                        year:this.form.year,
                        last_month:input3,
                        current_month:this.current_month,
                        next_month:input4,
                        month_type:this.batchObj.methods,
                        start_date:this.batchObj.day,
                        end_date:this.batchObj.day2,

                    }

                    await http.post('/wapi/sales/batchSetSalesDatePlanTwo', data).then(res => {
                        if(res.success){
                            this.getFillSalesDatesList()
                            this.dialogVisible2=false
                        }else {
                            Message.error(res.message);
                        }
                        this.dialogVisible2=false
                        this.loading=false
                    })
                } catch (e) {
                    this.dialogVisible2=false
                    this.loading=false

                }
            },
            add2(){
                this.batchSetSalesDatePlanTwo2()
            },
            async batchSetSalesDatePlanTwo2() {
                try {
                    let input3=''
                    if(this.batchObj2.checked==true){
                        input3 = this.batchObj2.input3
                    }else {
                        input3="0"
                    }
                    if(this.batchObj2.checked2==true){
                        this.current_month="1"
                    }else {
                        this.current_month="0"
                    }
                    let input4=''
                    if(this.batchObj2.checked3==true){
                        input4 = this.batchObj2.input4
                    }else {
                        input4="0"
                    }
                    this.loading=true

                    let data = {
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        user_id:this.$store.getters.getUser.user_id,
                        category:'FORECAST',
                        year:this.form.year,
                        last_month:input3,
                        current_month:this.current_month,
                        next_month:input4,
                        month_type:this.batchObj2.methods,
                        start_date:this.batchObj2.day,
                        end_date:this.batchObj2.day2,

                    }

                    await http.post('/wapi/sales/batchSetSalesDatePlanTwo', data).then(res => {
                        if(res.success){
                            this.getFillSalesDatesList()
                            this.dialogVisible5=false
                        }else {
                            Message.error(res.message);
                        }
                        this.dialogVisible5=false
                        this.loading=false
                    })
                } catch (e) {
                    this.dialogVisible5=false
                    this.loading=false
                }
            },
            add3(){
                this.batchSetSalesDatePlanTwo3()
            },
            async batchSetSalesDatePlanTwo3() {
                try {
                    let input3=''
                    if(this.batchObj3.checked==true){
                        input3 = this.batchObj3.input3
                    }else {
                        input3="0"
                    }
                    if(this.batchObj3.checked2==true){
                        this.current_month=1
                    }else {
                        this.current_month="0"
                    }
                    let input4=''
                    if(this.batchObj3.checked3==true){
                        input4 = this.batchObj3.input4
                    }else {
                        input4="0"
                    }
                    this.loading=true
                    let data = {
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        user_id:this.$store.getters.getUser.user_id,
                        category:'ACTUAL',
                        year:this.form.year,
                        last_month:input3,
                        current_month:this.current_month,
                        next_month:input4,
                        month_type:this.batchObj3.methods,
                        start_date:this.batchObj3.day,
                        end_date:this.batchObj3.day2,

                    }

                    await http.post('/wapi/sales/batchSetSalesDatePlanTwo', data).then(res => {
                        if(res.success){
                            this.getFillSalesDatesList()
                            this.dialogVisible6=false
                        }else {
                            Message.error(res.message);
                        }
                        this.dialogVisible6=false
                        this.loading=false
                    })
                } catch (e) {
                    this.dialogVisible5=false
                    this.loading=false
                }
            },
            sheding(){
                this.batchSetSalesDatePlanOne()
            },
            sheding2(){
                this.batchSetSalesDatePlanOne2()
            },
            sheding3(){
                this.batchSetSalesDatePlanOne3()
            },
            async batchSetSalesDatePlanOne3() {
                try {


                    this.loading=true
                    let data = {
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        user_id:this.$store.getters.getUser.user_id,
                        category:'ACTUAL',
                        year:this.form.year,
                        fill_year:this.batchObj3.year,
                        month:this.batchObj3.checkedCities,
                        start_date:this.batchObj3.time[0] == null ? "":this.batchObj3.time[0],
                        end_date:this.batchObj3.time[1]  == null ? "":this.batchObj3.time[1],

                    }

                    await http.post('/wapi/sales/batchSetSalesDatePlanOne', data).then(res => {
                        if(res.success){
                            this.getFillSalesDatesList()
                            this.dialogVisible6=false
                        }else {
                            Message.error(res.message);
                        }
                        this.dialogVisible6=false
                        this.loading=false
                    })
                } catch (e) {
                    this.dialogVisible6=false
                    this.loading=false
                }
            },
            async batchSetSalesDatePlanOne2() {
                try {


                    this.loading=true
                    let data = {
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        user_id:this.$store.getters.getUser.user_id,
                        category:'FORECAST',
                        year:this.form.year,
                        fill_year:this.batchObj2.year,
                        month:this.batchObj2.checkedCities,
                        start_date:this.batchObj2.time[0] == null ? "":this.batchObj2.time[0],
                        end_date:this.batchObj2.time[1]  == null ? "":this.batchObj2.time[1],

                    }

                    await http.post('/wapi/sales/batchSetSalesDatePlanOne', data).then(res => {
                        if(res.success){
                            this.getFillSalesDatesList()
                            this.dialogVisible5=false
                        }else {
                            Message.error(res.message);
                        }
                        this.dialogVisible5=false
                        this.loading=false
                    })
                } catch (e) {
                    this.dialogVisible5=false
                    this.loading=false
                }
            },
            async batchSetSalesDatePlanOne() {
                try {


                    this.loading=true
                    let data = {
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        user_id:this.$store.getters.getUser.user_id,
                        category:'TARGET',
                        year:this.form.year,
                        fill_year:this.batchObj.year,
                        month:this.batchObj.checkedCities,
                        start_date:this.batchObj.time[0] == null ? "":this.batchObj.time[0],
                        end_date:this.batchObj.time[1]  == null ? "":this.batchObj.time[1],

                    }

                    await http.post('/wapi/sales/batchSetSalesDatePlanOne', data).then(res => {
                        if(res.success){
                            this.getFillSalesDatesList()
                            this.dialogVisible2=false
                        }else {
                            Message.error(res.message);
                        }
                        this.dialogVisible2=false
                        this.loading=false
                    })
                } catch (e) {
                    this.dialogVisible2=false
                    this.loading=false
                }
            },
            handleCheckAllChange(val) {

                if (val){
                    this.batchObj.checkedCities = []
                    for (var i = 0; i < this.cities.length; i++){
                        this.batchObj.checkedCities.push(this.cities[i].value)
                    }
                }
                else {
                    this.batchObj.checkedCities = []
                }
                this.isIndeterminate = false;
            },
            handleCheckedCitiesChange(value){

                let checkedCount = value.length;
                this.batchObj.checkAll = checkedCount === this.cities.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
            },
            handleCheckAllChange2(val) {

                if (val){
                    this.batchObj2.checkedCities = []
                    for (var i = 0; i < this.cities.length; i++){
                        this.batchObj2.checkedCities.push(this.cities[i].value)
                    }
                }
                else {
                    this.batchObj2.checkedCities = []
                }
                this.isIndeterminate = false;
            },
            handleCheckedCitiesChange2(value){

                let checkedCount = value.length;
                this.batchObj2.checkAll = checkedCount === this.cities.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
            },
            handleCheckAllChange3(val) {

                if (val){
                    this.batchObj3.checkedCities = []
                    for (var i = 0; i < this.cities.length; i++){
                        this.batchObj3.checkedCities.push(this.cities[i].value)
                    }
                }
                else {
                    this.batchObj3.checkedCities = []
                }
                this.isIndeterminate = false;
            },
            handleCheckedCitiesChange3(value){

                let checkedCount = value.length;
                this.batchObj3.checkAll = checkedCount === this.cities.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
            },
            tianjia(){
                // console.log(this.targetObj,1233)
                if (this.formlist.time.length == 2) {
                    if (this.formlist.time[0].trim() == '' || this.formlist.time[1].trim() == '') {
                        Message.error("请选择日期");
                        return
                    }
                }
                else {
                    Message.error("请选择日期");
                    return
                }
                let obj = {}
                obj.start_date = this.formlist.time[0] == null ? "":this.formlist.time[0]
                obj.end_date = this.formlist.time[1]  == null ? "":this.formlist.time[1]
                obj.sales_month = this.sales_month
                obj.category = 'TARGET',
                this.targetObj.array.push(obj)
                // console.log(this.targetObj.array,89)
               // this.addSalesDate()
            },
            tianjia2(){
                if (this.formlist2.time.length == 2) {
                    if (this.formlist2.time[0].trim() == '' || this.formlist2.time[1].trim() == '') {
                        Message.error("请选择日期");
                        return
                    }
                }
                else {
                    Message.error("请选择日期");
                    return
                }
                let obj = {}
                obj.start_date = this.formlist2.time[0] == null ? "":this.formlist2.time[0]
                obj.end_date = this.formlist2.time[1]  == null ? "":this.formlist2.time[1]
                obj.sales_month = this.sales_month
                obj.category = 'FORECAST',
                    this.forecasObj.array.push(obj)
                // this.addSalesDate2()
            },
            tianjia3(){
                if (this.formlist3.time.length == 2) {
                    if (this.formlist3.time[0].trim() == '' || this.formlist3.time[1].trim() == '') {
                        Message.error("请选择日期");
                        return
                    }
                }
                else {
                    Message.error("请选择日期");
                    return
                }
                let obj = {}
                obj.start_date = this.formlist.time[0] == null ? "":this.formlist.time[0]
                obj.end_date = this.formlist.time[1]  == null ? "":this.formlist.time[1]
                obj.sales_month = this.sales_month
                obj.category = 'ACTUAL',
                    this.actualObj.array.push(obj)
                // this.addSalesDate3()

            },
            async addSalesDate() {
                try {
                    // this.loading=true
                    let data = {
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        user_id:this.$store.getters.getUser.user_id,
                        category:'TARGET',
                        dateArray:this.targetObj.array,
                        deleteArray:this.targetObj.deleteArray,
                        sales_month:this.sales_month
                    }

                    await http.post('/wapi/sales/addSalesDate', data).then(res => {
                        if(res.success){
                            this.getFillSalesDatesList()
                            // this.targetObj.array.push(res.data);
                        }else {
                            Message.error(res.message);
                        }
                        this.dialogVisible = false
                        // this.loading=false
                    })
                } catch (e) {
                    this.loading=false

                }
            },
            async addSalesDate2() {
                try {

                    // this.loading=true
                    let data = {
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        user_id:this.$store.getters.getUser.user_id,
                        category:'FORECAST',
                        dateArray:this.forecasObj.array,
                        deleteArray:this.forecasObj.deleteArray,
                        sales_month:this.sales_month
                    }

                    await http.post('/wapi/sales/addSalesDate', data).then(res => {
                        if(res.success){
                            this.getFillSalesDatesList()
                            // this.forecasObj.array.push(res.data[0]);
                        }else {
                            Message.error(res.message);
                        }
                        this.dialogVisible3 = false
                        this.loading=false
                    })
                } catch (e) {
                    // this.loading=false

                }
            },
            async addSalesDate3() {
                try {
                    // this.loading=true
                    let data = {
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        user_id:this.$store.getters.getUser.user_id,
                        category:'ACTUAL',
                        dateArray:this.actualObj.array,
                        deleteArray:this.actualObj.deleteArray,
                        sales_month:this.sales_month
                    }

                    await http.post('/wapi/sales/addSalesDate', data).then(res => {
                        if(res.success){
                            this.getFillSalesDatesList()
                            // this.actualObj.array.push(res.data[0]);
                        }else {
                            Message.error(res.message);
                        }
                        this.dialogVisible4 = false
                        // this.loading=false
                    })
                } catch (e) {
                    this.loading=false
                }
            },
            fangfa(){
               if(this.form.year!==''){
                   this.getFillSalesDatesList()
               }
            },
            handleClose(item,index){
                // console.log(item)
                if(item.key_id){
                    this.targetObj.deleteArray = []
                    this.targetObj.deleteArray.push(item)
                    this.targetObj.array.splice(index,1)
                }else {
                    this.targetObj.array.splice(index,1)
                }
            },
            async deleteSalesDate(item,index) {
                try {
                    let key_id = item.key_id
                    let data = {
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        key_id:key_id
                    }

                    await http.post('/wapi/sales/deleteSalesDate', data).then(res => {
                        if(res.success){
                            this.targetObj.array.splice(index,1);

                        }else {
                            Message.error(res.message);
                        }
                    })
                } catch (e) {


                }
            },

            handleClose2(item,index){
                // console.log(item)
                if(item.key_id){
                    this.forecasObj.deleteArray = []
                    this.forecasObj.deleteArray.push(item)
                    this.forecasObj.array.splice(index,1)
                    // this.deleteSalesDate2(item,index)
                }else {
                    this.forecasObj.array.splice(index,1)
                }
                // this.forecasObj.array.splice(index, 1);
                // this.deleteSalesDate2(item,index)
            },
            async deleteSalesDate2(item,index) {
                try {
                    let key_id = item.key_id
                    let data = {
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        key_id:key_id
                    }

                    await http.post('/wapi/sales/deleteSalesDate', data).then(res => {
                        if(res.success){
                            this.forecasObj.array.splice(index, 1);

                        }else {
                            Message.error(res.message);
                        }
                    })
                } catch (e) {


                }
            },
            handleClose3(item,index){
                // console.log(item)
                //
                // this.deleteSalesDate3(item,index)
                if(item.key_id){
                    this.actualObj.deleteArray = []
                    this.actualObj.deleteArray.push(item)
                    this.actualObj.array.splice(index,1)
                    // this.deleteSalesDate3(item,index)
                }else {
                    this.actualObj.array.splice(index,1)
                }
            },
            async deleteSalesDate3(item,index) {
                try {
                    let key_id = item.key_id
                    let data = {
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        key_id:key_id
                    }
                    await http.post('/wapi/sales/deleteSalesDate', data).then(res => {
                        if(res.success){
                            this.actualObj.array.splice(index, 1);
                        }else {
                            Message.error(res.message);
                        }
                    })
                } catch (e) {


                }
            },


            renderHeader(h, {column, $index}) {


                return [
                    h('div', null, [
                        h('span',null,column.label),
                        h('button',{class:'el-button1', on :{
                            click: () => {

                                this.dianji(column,$index);  }  }, },'设定'
                        )
                    ])
                ]
            },
            renderHeader2(h, {column, $index}) {

                // console.log(h)
                // console.log(column)
                // console.log($index)
                return [
                    h('div', null, [
                        h('span',null,column.label),
                        h('button',{class:'el-button1', on :{
                            click: () => {

                                this.dianji2(column,$index);  }  }, },'设定'
                        )
                    ])
                ]
            },
            renderHeader3(h, {column, $index}) {

                // console.log(h)
                // console.log(column)
                // console.log($index)
                return [
                    h('div', null, [
                        h('span',null,column.label),
                        h('button',{class:'el-button1', on :{
                            click: () => {

                                this.dianji3(column,$index);  }  }, },'设定'
                        )
                    ])
                ]
            },

            handelDelete(){
                this.dialogVisible2=true
                this.batchObj={
                    time: '',
                    year:'',
                    checkedCities: [],
                    checkAll: false,
                    day:'',
                    methods: 'C',
                    day2:'',
                    input3: '',
                    input4: '',
                    checked:false,
                    checked2:false,
                    checked3:false,
                }
            },
            handelDelete2(){
                this.dialogVisible5=true
                this.batchObj2={
                    time: '',
                    year:'',
                    checkedCities: [],
                    checkAll: false,
                    methods: 'C',
                    day:'',
                    day2:'',
                    input3: '',
                    input4: '',
                    checked:false,
                    checked2:false,
                    checked3:false,
                }
            },
            handelDelete3(){
                this.dialogVisible6=true
                this.batchObj3={
                    time: '',
                    year:'',
                    checkedCities: [],
                    checkAll: false,
                    day:'',
                    methods: 'C',
                   day2:'',
                    input3: '',
                    input4: '',
                    checked:false,
                    checked2:false,
                    checked3:false,
                }
            },
            dianji(column,index){
               let target = this.targetArray[0]
                if(index==1){
                    this.targetObj = JSON.parse(JSON.stringify(target.m1))
                }
                else if(index==2){
                    this.targetObj = JSON.parse(JSON.stringify(target.m2))
                }
                else if(index==3){
                   this.targetObj = JSON.parse(JSON.stringify(target.m3))
                }
                else if(index==4){
                    this.targetObj = JSON.parse(JSON.stringify(target.m4))
                }
                else if(index==5){
                    this.targetObj = JSON.parse(JSON.stringify(target.m5))
                }
                else if(index==6){
                    this.targetObj = JSON.parse(JSON.stringify(target.m6))
                }
                else if(index==7){
                    this.targetObj= JSON.parse(JSON.stringify(target.m7))
                }
                else if(index==8){
                    this.targetObj= JSON.parse(JSON.stringify(target.m8))
                }
                else if(index==9){
                    this.targetObj=JSON.parse(JSON.stringify(target.m9))
                }
                else if(index==10){
                    this.targetObj=JSON.parse(JSON.stringify(target.m10))
                }
                else if(index==11){
                    this.targetObj=JSON.parse(JSON.stringify(target.m11))
                }
                else if(index==12){
                    this.targetObj=JSON.parse(JSON.stringify(target.m12))
                }
                console.log(target)
                this.column = column.label
                this.dialogVisible = true
                if(index<10){
                    this.sales_month = (this.form.year + "0" + index).toString()

                }else {
                    this.sales_month = (this.form.year+index).toString()
                }
                this.formlist={
                    time:''
                }

            },
            dianji2(column,index){
                this.formlist2={
                    time:''
                }
                let forecas = this.tableData2[0]
                if(index==1){
                    this.forecasObj = JSON.parse(JSON.stringify(forecas.m1))
                }
                else if(index==2){
                    this.forecasObj = JSON.parse(JSON.stringify(forecas.m2))
                }
                else if(index==3){
                    this.forecasObj =  JSON.parse(JSON.stringify(forecas.m3))
                }
                else if(index==4){
                    this.forecasObj =  JSON.parse(JSON.stringify(forecas.m4))
                }
                else if(index==5){
                    this.forecasObj =  JSON.parse(JSON.stringify(forecas.m5))
                }
                else if(index==6){
                    this.forecasObj =  JSON.parse(JSON.stringify(forecas.m6))
                }
                else if(index==7){
                    this.forecasObj= JSON.parse(JSON.stringify(forecas.m7))
                }
                else if(index==8){
                    this.forecasObj= JSON.parse(JSON.stringify(forecas.m8))
                }
                else if(index==9){
                    this.forecasObj= JSON.parse(JSON.stringify(forecas.m9))
                }
                else if(index==10){
                    this.forecasObj= JSON.parse(JSON.stringify(forecas.m10))
                }
                else if(index==11){
                    this.forecasObj= JSON.parse(JSON.stringify(forecas.m11))
                }
                else if(index==12){
                    this.forecasObj= JSON.parse(JSON.stringify(forecas.m12))
                }
                this.column = column.label
                this.dialogVisible3 = true
                if(index<10){
                    this.sales_month = (this.form.year + "0" + index).toString()

                }else {
                    this.sales_month = (this.form.year+index).toString()
                }

            },
            dianji3(column,index){
                this.formlist3={
                    time:''
                }
                let actual = this.tableData3[0]
                if(index==1){
                    this.actualObj = JSON.parse(JSON.stringify(actual.m1))
                }
                else if(index==2){
                    this.actualObj =JSON.parse(JSON.stringify(actual.m2))
                }
                else if(index==3){
                    this.actualObj = JSON.parse(JSON.stringify(actual.m3))
                }
                else if(index==4){
                    this.actualObj = JSON.parse(JSON.stringify(actual.m4))
                }
                else if(index==5){
                    this.actualObj = JSON.parse(JSON.stringify(actual.m5))
                }
                else if(index==6){
                    this.actualObj = JSON.parse(JSON.stringify(actual.m6))
                }
                else if(index==7){
                    this.actualObj=JSON.parse(JSON.stringify(actual.m7))
                }
                else if(index==8){
                    this.actualObj=JSON.parse(JSON.stringify(actual.m8))
                }
                else if(index==9){
                    this.actualObj=JSON.parse(JSON.stringify(actual.m9))
                }
                else if(index==10){
                    this.actualObj=JSON.parse(JSON.stringify(actual.m10))
                }
                else if(index==11){
                    this.actualObj=JSON.parse(JSON.stringify(actual.m11))
                }
                else if(index==12){
                    this.actualObj=JSON.parse(JSON.stringify(actual.m12))
                }
                this.column = column.label
                this.dialogVisible4 = true
                if(index<10){
                    this.sales_month = (this.form.year + "0" + index).toString()

                }else {
                    this.sales_month = (this.form.year+index).toString()
                }

            },

            async getFillSalesDatesList() {
                try {
                    const loading = this.$loading({
                        lock: true,
                        text: '拼命加载中',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                   let data={
                       tenant_id:this.$store.getters.getUser.tenant_id,
                       date: this.form.year
                   }
                    await http.post('/wapi/sales/getFillSalesDatesList', data).then(res => {
                       if(res.success){
                           this.targetArray = []
                           let target = {
                               m1: {array : []},
                               m2: {array : []},
                               m3: {array : []},
                               m4: {array : []},
                               m5: {array : []},
                               m6: {array : []},
                               m7: {array : []},
                               m8: {array : []},
                               m9: {array : []},
                               m10: {array : []},
                               m11: {array : []},
                               m12: {array : []},
                           }

                           for (let i=0;i<res.data.targetArray.length;i++){
                               let array=res.data.targetArray[i]
                               // console.log(array)

                               for (let j = 0; j < array.length; j++) {
                                   let o = array[j]
                                   if (i == 0) {
                                       target.m1.array.push(o)
                                   }
                                   else if (i == 1) {
                                       target.m2.array.push(o)
                                   }
                                   else if (i == 2) {
                                       target.m3.array.push(o)
                                   }
                                   else if (i == 3) {
                                       target.m4.array.push(o)
                                   }
                                   else if (i == 4) {
                                       target.m5.array.push(o)
                                   }
                                   else if (i == 5) {
                                       target.m6.array.push(o)
                                   }
                                   else if (i == 6) {
                                       target.m7.array.push(o)
                                   }

                                   else if (i == 7) {
                                       target.m8.array.push(o)
                                   }
                                   else if (i == 8) {
                                       target.m9.array.push(o)
                                   }
                                   else if (i == 9) {
                                       target.m10.array.push(o)
                                   }
                                   else if (i == 10) {
                                       target.m11.array.push(o)
                                   }
                                   else if (i == 11) {
                                       target.m12.array.push(o)
                                   }

                               }
                           }
                           this.targetArray.push(target)



                           this.tableData2 = []
                           let forecas = {
                               m1: {array : []},
                               m2: {array : []},
                               m3: {array : []},
                               m4: {array : []},
                               m5: {array : []},
                               m6: {array : []},
                               m7: {array : []},
                               m8: {array : []},
                               m9: {array : []},
                               m10: {array : []},
                               m11: {array : []},
                               m12: {array : []},
                           }
                           for(let a=0;a<res.data.forecastArray.length;a++){
                               let array2 = res.data.forecastArray[a]
                               for(let z=0;z<array2.length;z++){
                                   let q =array2[z]
                                   if(a==0){
                                       forecas.m1.array.push(q)
                                   }
                                   else if(a==1){
                                       forecas.m2.array.push(q)
                                   }
                                   else if(a==2){
                                       forecas.m3.array.push(q)
                                   }
                                   else if(a==3){
                                       forecas.m4.array.push(q)
                                   }
                                   else if(a==4){
                                       forecas.m5.array.push(q)
                                   }
                                   else if(a==5){
                                       forecas.m6.array.push(q)
                                   }
                                   else if(a==6){
                                       forecas.m7.array.push(q)
                                   }
                                   else if(a==7){
                                       forecas.m8.array.push(q)
                                   }
                                   else if(a==8){
                                       forecas.m9.array.push(q)
                                   }
                                   else if(a==9){
                                       forecas.m10.array.push(q)
                                   }
                                   else if(a==10){
                                       forecas.m11.array.push(q)
                                   }
                                   else if(a==11){
                                       forecas.m12.array.push(q)
                                   }
                               }
                           }
                           this.tableData2.push(forecas)

                           // this.tableData3 = []
                           // let  actual = {
                           //     m1: {array : []},
                           //     m2: {array : []},
                           //     m3: {array : []},
                           //     m4: {array : []},
                           //     m5: {array : []},
                           //     m6: {array : []},
                           //     m7: {array : []},
                           //     m8: {array : []},
                           //     m9: {array : []},
                           //     m10: {array : []},
                           //     m11: {array : []},
                           //     m12: {array : []},
                           // }
                           // for(var i=0; i<res.data.actualArray.length;i++){
                           //     let array = res.data.actualArray[i]
                           //     for (let j=0;j<array.length;j++){
                           //         let o = array[j]
                           //             if (i == 0) {
                           //                 actual.m1.array.push(o)
                           //             }
                           //             else if (i == 1) {
                           //                 actual.m2.array.push(o)
                           //             }
                           //             else if (i == 2) {
                           //                 actual.m3.array.push(o)
                           //             }
                           //             else if (i == 3) {
                           //                 actual.m4.array.push(o)
                           //             }
                           //             else if (i == 4) {
                           //                 actual.m5.array.push(o)
                           //             }
                           //             else if (i == 5) {
                           //                 actual.m6.array.push(o)
                           //             }
                           //
                           //             else if (i == 6) {
                           //                 actual.m7.array.push(o)
                           //             }
                           //             else if (i == 7) {
                           //                 actual.m8.array.push(o)
                           //             }
                           //             else if (i == 8) {
                           //                 actual.m9.array.push(o)
                           //             }
                           //             else if (i == 9) {
                           //                 actual.m10.array.push(o)
                           //             }
                           //             else if (i == 10) {
                           //                 actual.m11.array.push(o)
                           //             }
                           //             else if (i == 11) {
                           //                 actual.m12.array.push(o)
                           //             }
                           //     }
                           //
                           // }
                           // this.tableData3.push(actual)
                           loading.close()
                       }else {
                           Message.error(res.message);
                           loading.close()
                       }

                    })
                } catch (e) {


                }
            },
        },

        computed:{

        },
        mounted(){

        },
        watch:{}
    }
</script>

<style lang="scss" module>
    .container {
        background: white;
        height: 1000%;

    }

</style>
<style scoped>
    .formlistStyle >>> .el-form-item__label{
        font-size: 14px;
        color: #4A90E2;
    }
    .textObj >>>.el-form-item__label{
     text-align: left;
    }
    .el-input--prefix .el-input__inner{
        color:#FF9901;
    }
    #loading .el-checkbox{
        width: 45px;
    }
    .headerStyle2:nth-of-type(1) > div {
        color: #4A90E2;
        min-width: 10px;
    }
    .headerStyle2:nth-last-of-type(2) > div {
        color: #4A90E2;
        min-width: 10px;

    }
    .el-table th div{
        margin-left: -4px;
        min-width: 127px;
    }
    #loading >>> .el-input-number.is-controls-right .el-input-number__increase{
     width: 20px;
    }
    #loading >>> .el-input-number.is-controls-right .el-input-number__decrease{
        width: 20px;
    }
</style>
<style>
    .el-button1 {
        color: #fff;
        background-color: #ff9901;
        border: 1px solid #ff9901;
        border-radius: 3px;
        margin-left: 4px;
    }

    #div1{
        display: none;
    }
    #div2{
        display: none;
    }
    #div3{
        display: none;
    }
    .headerStyle2 > div {
        font-size: 14px;
        color: #585757;
        font-weight: bold;
    }







</style>





// WEBPACK FOOTER //
// src/pages/salesdataManagements/dataentry.vue